import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import Layout from "../../layouts/Layout";
import ProtectedRoute from "../Routes/ProtectedRoute";

const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const Login = React.lazy(() => import("../../pages/login/Login"));
const Unauthorized = React.lazy(() => import("../../pages/unauthorize/Unauthorize"));


const AppRoutes = (props) => {
  return (
    <Router>
      <React.Suspense fallback={<PageLoader />}>
        <Routes>

          {/* Redirect "/" to "/login" */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          <Route
            name="Layout"
            path="/"
            element={
              <ProtectedRoute>
                <Layout componentRoutes={props.componentRoutes}></Layout>
              </ProtectedRoute>
            }
          >
            {props.componentRoutes &&
              props.componentRoutes.map((route, idx) => {
                return (
                  route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      element={<route.component authorizeRoleType={route.roleTypes} />}
                    />
                  )
                );
              })}
          </Route>
          <Route exact name="Login" path="/login" element={<Login />} />
          {/* <Route path="*" element={<Login />} /> */}
          <Route exact name="Unauthorized" path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    </Router>
  );
};
export default AppRoutes;
